<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">شرایط کار</h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label fw-bold">شرایط محیط کار</label>
          <input
              type="text"
              class="form-control"
              placeholder="شرایط محیط کار را توضیح دهید"
              v-model="jobDescription.work_conditions"
          />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label fw-bold">خطرات</label>
          <input
              type="text"
              class="form-control"
              placeholder="خطرات شغل را توضیح دهید"
              v-model="jobDescription.hazards"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label fw-bold">ارگونومی</label>
          <input
              type="text"
              class="form-control"
              placeholder="مسائل ارگونومی را توضیح دهید"
              v-model="jobDescription.ergonomics"
          />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label fw-bold">استرس و سایر دلایل عدم تمرکز</label>
          <input
              type="text"
              class="form-control"
              placeholder="دلایل استرس و عدم تمرکز را توضیح دهید"
              v-model="jobDescription.stress_factors"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    jobDescription: {
      get() {
        return this.$store.state.jobDescription.jobDescription;
      }
    },
  },
}
</script>